import Vue from 'vue';
import Component from 'vue-class-component';
import 'wc-lib/src/wc-converters/index';
import {Modal} from 'wc-lib';

@Component({
  template: require('./app.html'),
  components: {
    'wc-modal': Modal
  }
})
export class App extends Vue {
  showTerms = localStorage.getItem("gasbbterms") === 'true' ? false : true;

  termsAgree() {
    this.showTerms = false;
    localStorage.setItem('gasbbterms', 'true');
  }
}





// WEBPACK FOOTER //
// src/app.ts